import { Helmet } from 'react-helmet-async'

interface SeoProps {
  title?: string
  description?: string
  canonical?: string
  ogImage?: string
  noIndex?: boolean
}

export function Seo({
  title = 'ShopAdverts',
  description = 'Default app description',
  canonical = 'https://yourdomain.com',
  ogImage = 'https://yourdomain.com/og-image.png',
  noIndex = false
}: SeoProps) {
  const siteTitle = title ? `${title}` : 'Your App Name'

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta content={description} name="description" />
      <link href={canonical} rel="canonical" />

      {/* Open Graph / Facebook */}
      <meta content="website" property="og:type" />
      <meta content={canonical} property="og:url" />
      <meta content={siteTitle} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={ogImage} property="og:image" />

      {/* Twitter */}
      <meta content="summary_large_image" name="twitter:card" />
      <meta content={canonical} name="twitter:url" />
      <meta content={siteTitle} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content={ogImage} name="twitter:image" />

      {noIndex && <meta content="noindex, nofollow" name="robots" />}
    </Helmet>
  )
}
